import React from 'react';
import '../../scss/profile_header.scss';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

function ProfileHeader() {
    const navigate = useNavigate();
    const userRole = useSelector((state) => state.role);

    return(
        <>
            <div className='profile-header-container'>
                <div onClick={() => navigate('/profile')} style={{color : `${window.location.href.includes('profile') ? '#656565' : ''}`, 
                    fontFamily : `${window.location.href.includes('profile') ? 'Lato-Semibold' : ''}`,
                    borderBottom : `${window.location.href.includes('profile') ? '2px solid #059CDC' : 'none'}`}}>
                    Profile
                </div>
                {userRole == 1 && 
                <div onClick={() => navigate('/roles')} style={{color : `${window.location.href.includes('roles') ? '#656565' : ''}`, 
                    fontFamily : `${window.location.href.includes('/roles') ? 'Lato-Semibold' : ''}`,
                    borderBottom : `${window.location.href.includes('/roles') ? '2px solid #059CDC' : 'none'}`}}>
                    Roles
                </div>}
                {userRole == 1 && 
                <div onClick={() => navigate('/users/list')} style={{color : `${window.location.href.includes('users') ? '#656565' : ''}`, 
                    fontFamily : `${window.location.href.includes('users') ? 'Lato-Semibold' : ''}`,
                    borderBottom : `${window.location.href.includes('users') ? '2px solid #059CDC' : 'none'}`}}>
                    Users
                </div>}
            </div>
        </>
    )
}

export default ProfileHeader;